import { render, staticRenderFns } from "./DaftarPenerima.vue?vue&type=template&id=0bbd374e&scoped=true&"
import script from "./DaftarPenerima.vue?vue&type=script&lang=js&"
export * from "./DaftarPenerima.vue?vue&type=script&lang=js&"
import style0 from "./DaftarPenerima.vue?vue&type=style&index=0&id=0bbd374e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbd374e",
  null
  
)

export default component.exports